import api from './api';

export interface AIStatus {
  enabled: boolean;
  openAIFallbackEnabled: boolean;
  queueSize: number;
  processing: boolean;
}

export interface AIControlResponse {
  message: string;
  aiStatus: AIStatus;
}

export const aiService = {
  // Get AI status
  async getStatus(): Promise<{ aiStatus: AIStatus; timestamp: string }> {
    const response = await api.get('/message-queue/ai/status');
    return response.data;
  },

  // Pause AI processing
  async pause(): Promise<AIControlResponse> {
    const response = await api.post('/message-queue/ai/pause');
    return response.data;
  },

  // Resume AI processing
  async resume(): Promise<AIControlResponse> {
    const response = await api.post('/message-queue/ai/resume');
    return response.data;
  },

  async setOpenAIFallback(enabled: boolean): Promise<AIControlResponse> {
    const response = await api.post('/message-queue/ai/openai-fallback', { enabled });
    return response.data;
  },

  // Get queue stats (includes AI status)
  async getQueueStats(): Promise<{
    queueSize: number;
    processing: boolean;
    aiEnabled: boolean;
    statusCounts: Record<string, number>;
    rateLimitDelay: number;
    batchSize: number;
    timestamp: string;
  }> {
    const response = await api.get('/message-queue/status');
    return response.data;
  }
};

export default aiService;
